import { isOwnedStation } from '@app/core/stations/helpers';
import { useStationsFinder } from '@app/core/stations/hooks/useStations';
import { Station } from '@mi-front/core';

type FragmentWithStation = {
  stationId: string;
};

/**
 * Resolves the fragment's station and whether the current user can publish to it.
 * Returns safe defaults while the fragment is still loading.
 */
export function useFragmentCanPublish(fragment: FragmentWithStation | undefined): {
  station: Station | undefined;
  canPublish: boolean;
} {
  const findStation = useStationsFinder();
  const station = fragment ? (findStation(fragment.stationId) ?? undefined) : undefined;
  const canPublish = station ? isOwnedStation(station) : false;

  return { station, canPublish };
}
